import React, { useRef } from "react";

const StepFileUpload = ({ file, setFile, setDone }) => {
  const inputRef = useRef();

  const handleFile = f => {
    setFile(f);
    setDone(true);
  };

  const onDrop = e => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const onChange = e => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const removeFile = () => {
    setFile(null);
    setDone(false);
  };

  return (
    <div>
      <div
        className="border-2 border-dashed border-blue-300 rounded-lg p-6 text-center text-blue-600 bg-blue-50 cursor-pointer hover:bg-blue-100 transition-all"
        onDrop={onDrop}
        onDragOver={e => e.preventDefault()}
        onClick={() => inputRef.current.click()}
      >
        ⬇️ 여기에 파일을 드래그하거나 <span className="underline">[파일 선택]</span>
        <input
          type="file"
          className="hidden"
          ref={inputRef}
          onChange={onChange}
        />
      </div>
      {file && (
        <div className="mt-3 flex justify-between items-center bg-white rounded shadow p-3 border">
          <span className="font-medium text-blue-800">{file.name} ({file.size} bytes)</span>
          <button
            className="px-3 py-1 rounded bg-red-100 text-red-600 font-semibold hover:bg-red-200 transition-colors"
            onClick={removeFile}
          >
            삭제
          </button>
        </div>
      )}
    </div>
  );
};

export default StepFileUpload; 